import React, { useEffect, useState } from 'react'
import DollarImg from '../../assets/dollar.svg'
import CartImg from '../../assets/cart.svg'
import BarChart from '../../components/charts/BarChart'
import { Card, CardContent, Paper } from '@mui/material'
import { AreaChart } from '../../components/charts/AreaChart'
import { getAllSubsByY, getAnalysisyearly, getwholeAnalysis } from './utils'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './merchant.css'
import Spinner from '../../components/common/spinner'
import { LoadingSection } from '../../components/common/loading'
import countImage from '../../assets/count.png'
import saleImage from '../../assets/sale.png'
import dollarImage from '../../assets/dollars.png'
import CallIcon from '../../assets/call-icon.png'
// import HourIcon from '../assets/hours-icon.png'

import callImage from '../../assets/call.png'

const ReportsSection = ({ shopName }) => {
    const [reportType, setReportType] = useState("s");//s,q
    const [sales, setSales] = useState({ products: [], quantities: [], minutes: [], labels: [] })
    const [subsReport, setSubsReport] = useState({ subs: [], labels: [] });
    const [salesErr, setSalesErr] = useState(false);
    const [minsErr, setMinsErr] = useState(false);
    const [fetchLoad, setFetchLoad] = useState(true);
    const [wholeData, setWholeData] = useState({
        totalAmount: 0,
        totalQuantity: 0,
        totalMinutes: 0,
        totalCalls: 0,
        error:false,
    })
    const [subsFilter, setSubsFilter] = useState({ value: "This year", open: false, load: false, error: false });
    const [productsFilter, setProductsFilter] = useState({ value: "Last 6 months", open: false, load: false, error: false });
    // const [subsFilter, setSubsFilter] = useState({ value: "Last 6 months", open: false, load: false, error: false });
    const getSalesReports = async () => {
        const { data, sales, quantity, minutes, labels, error } = await getAnalysisyearly(shopName, "Last 6 months")
        if (error) {
            setMinsErr(true)
            return setSalesErr(true)
        };
        setSales({
            labels,
            quantities: quantity,
            minutes,
            products: sales,
        })
        // setMinutesReport({
        //     minutes,
        //     labels
        // })
        setFetchLoad(false)
    }
    const getWholeAna = async () => {
        const { data, error } = await getwholeAnalysis(shopName)
        if (!error) {
            setWholeData({...data,error:false});
        } else {
            setWholeData(p=>({
                ...p,
                error:true
            }))
        }
    }
    useEffect(() => {
        (async () =>{ 
            await getWholeAna()
            await getSalesReports()
        })()
    }, [])
    const handelSelectProduct = async (e, year) => {

        e.stopPropagation()
        if (year == productsFilter.value) return setProductsFilter(p => ({
            ...p,
            open: false,
        }));
        setProductsFilter(p => ({
            ...p,
            value: year,
            load: true,
            open: false,
        }));
        await getAnalysis(year)
        setProductsFilter(p => ({ ...p, load: false }));

    }
    const handelSelectSubs = async (e, year) => {

        e.stopPropagation()
        if (year == subsFilter.value) return setSubsFilter(p => ({
            ...p,
            open: false,
        }));
        setSubsFilter(p => ({
            ...p,
            value: year,
            load: true,
            open: false,
        }));
        const month = new Date().getMonth();
        if (year =="This Year") year=new Date().getFullYear()
        const { data, labels, error } = await getAllSubsByY(shopName, 0, 12,year)
        setSubsFilter(p => ({ ...p, load: false }));
        setSubsReport({ subs: data, labels })
    }
    const getAnalysis = async (year) => {
        const { data, sales, quantity, minutes, labels, error } = await getAnalysisyearly(shopName, year)
        if (error) return false

        setSales({
            quantities: quantity,
            products: sales,
            minutes: minutes,
            labels
        })


        return true
    }
    const formatYears = () => {
        const current = new Date();
        let arr = ["Last 6 months"];
        let start = 2022
        while (start < +current.getFullYear()) {
            arr.push(start)
            start++
        }
        arr.push(+current.getFullYear())
        return arr
    }
    const formatSubs = () => {
        const current = new Date();
        let arr = ["This Year"];
        let start = 2022
        while (start < +current.getFullYear()) {
            arr.push(start)
            start++
        }
        // arr.push(+current.getFullYear())
        return arr
    }
    const getSubsThisYear = async (year, start, end) => {
        const { data, labels, error } = await getAllSubsByY(shopName, start, end,year);
        // console.log(data, "subsThisYear");
        setSubsReport(p => ({
            ...p,
            subs: data,
            labels
        }))
    }
    useEffect(() => {
        const date = new Date();
        shopName && (async () => await getSubsThisYear(date.getFullYear(), 0, 12))()
    }, [shopName])
    return (
        <div style={{
            // display:"flex",
            // justifyContent:"space-between"
        }}>
            {fetchLoad ? <LoadingSection /> :
                !wholeData.error && 
                <div style={{
                    padding: 10,
                    margin: "10px 0px",
                    borderRadius: 8,
                    border: "1px solid white",
                    boxShadow: "0px 0px 0px 1px #ccc",
                    backgroundColor: "white"
                }}>
                    <p style={{
                        fontSize: 20,
                        fontWeight: 500
                    }}>Store's all history Anaylsis</p>
                <div className="ana-history" style={{
                    padding:20,
                    display:"flex",
                    flexWrap: "wrap"
                    // justifyContent:"space-between"
                }}>
                    <div className='ana-hist-card' style={{
                        // display:"flex",
                        // // justifyContent:"center",
                        // marginRight:20,
                        // borderRadius:8,
                        // padding:20,
                        // minWidth:200,
                        // backgroundColor:"white",
                    }}>
                        {/* left */}
                        <div style={{
                            marginRight:10
                        }}>
                            <img src={dollarImage} alt="count-img" />
                        </div>
                        <div style={{
                            fontSize:20,
                            fontWeight:500
                        }}>
                            <p>${wholeData.totalAmount.toLocaleString('en-US')}</p>
                            <p style={{
                                fontSize:14,
                                color:"GrayText"
                            }}>Total Sales</p>
                        </div>
                    </div>
                    <div className='ana-hist-card' >
                        {/* left */}
                        <div style={{marginRight:20}}>
                            <img src={saleImage} alt="count-img" />
                        </div>
                        <div style={{
                            fontSize:20,
                            fontWeight:500
                        }}>
                            <p>{wholeData.totalQuantity.toLocaleString('en-US')}</p>
                            <p style={{
                                fontSize:14,
                                color:"GrayText"
                            }}>Total Products Quantity</p>
                        </div>
                    </div>
                    {/* minutes */}
                    <div className='ana-hist-card'>
                        {/* left */}
                        <div style={{ marginRight: 10 }}>
                            <img src={countImage} alt="minutes-img" />
                        </div>
                        <div style={{
                            fontSize:20,
                            fontWeight:500
                        }}>
                            <p>{wholeData.totalMinutes.toLocaleString('en-US')}</p>
                            <p style={{
                                fontSize:14,
                                color:"GrayText"
                            }}>Total Minutes</p>
                        </div>
                    </div>
                    {/* calls */}
                    <div className='ana-hist-card'>
                        {/* left */}
                        <div style={{marginRight:10}}>
                                    <img src={CallIcon} alt="call-img" height={40} width={40} />
                        </div>
                        <div style={{
                            fontSize:20,
                            fontWeight:500
                        }}>
                            <p>{wholeData.totalCalls.toLocaleString('en-US')}</p>
                            <p style={{
                                fontSize:14,
                                color:"GrayText"
                            }}>Total Calls</p>
                        </div>
                    </div>
                </div>
                </div>}
            {fetchLoad ? <LoadingSection /> : <Card sx={{ margin: "20px 0" }} title={<strong>Products Reports</strong>}  >
                <div style={{ margin: "10px 0px 5px 20px" }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <p style={{ fontWeight: 600, fontSize: 16, color: "GrayText" }}>Products Monthly Overview</p>
                        <div style={{
                            display: "flex",
                            position: "relative",
                            borderRadius: 4,
                            padding: 5,
                            height: 40,
                            width: 200,
                            border: "1px solid lightgray",
                            color: "black",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontSize: 18,
                            margin: "0 20px"
                        }}>
                            {productsFilter.load ? <Spinner color={"green"} /> : <p style={{ marginRight: 5 }}>{productsFilter.value}</p>}
                            <div onClick={() => {
                                if (productsFilter.load) return
                                setProductsFilter(p => ({ ...p, open: !p.open }))
                            }}
                                style={{ cursor: "pointer" }}
                            >
                                {productsFilter.open ? <KeyboardArrowUpIcon sx={{ padding: 0, margin: 0 }} /> : <KeyboardArrowDownIcon sx={{ padding: 0, margin: 0 }} color="primay" />}
                            </div>


                            {productsFilter.open && <div
                                style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 40,
                                    // paddingBottom:20,
                                    zIndex: 99,
                                    //   border: "1px solid lightgray",
                                    borderTop: "0px",
                                    borderRadius: 5,
                                    borderTopLeftRadius: 0,
                                    backgroundColor: "#f6f6f7",
                                }}
                            >
                                <div className='year-list' style={{ height: 120, overflow: "scroll", overflowX: "hidden" }}>
                                    {formatYears().map((h, i) => (
                                        <div
                                            onClick={async (e) => { await handelSelectProduct(e, h) }}
                                            style={{
                                                cursor: "pointer",
                                                height: 40,
                                                width: 200,
                                                backgroundColor: "",
                                                // borderBottom: "1px solid lightgray",
                                                display: "flex",
                                                padding: 10,
                                                alignItems: "center",
                                                fontWeight: 400,
                                                fontSize: 16,
                                                color: "#8B8D97",
                                            }}
                                        >
                                            <p>{h}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>}
                        </div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <div style={{
                            margin: "20px 10px",
                            textAlign: "center"
                        }} >
                            <div onClick={() => setReportType('s')}
                                style={{
                                    margin: "5px 0px",
                                    height: 70,
                                    width: 80,
                                    border: "1.5px solid gray",
                                    borderRadius: 4,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: reportType == 's' && "rgb(187 187 187)",
                                    cursor: "pointer",
                                }}>
                                <div style={{
                                    height: 40,
                                    width: 40,
                                    backgroundColor: "rgba(75, 70, 92, 0.08)",
                                    borderRadius: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <img src={DollarImg} />
                                </div>
                            </div>
                            <p style={{
                                fontWeight: 600, fontSize: 16,
                                letterSpacing: .5,
                                color: reportType == 's' ? "rgba(75, 70, 92, 1)" : "GrayText",
                                opacity: reportType !== 's' && .5
                            }}
                            >Sales</p>
                        </div>
                        <div style={{
                            margin: "20px 10px",
                            textAlign: "center"
                        }}>
                            <div onClick={() => setReportType('q')} style={{
                                margin: "5px 0px",
                                height: 70,
                                width: 80,
                                border: "1.5px solid gray",
                                borderRadius: 4,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: reportType == 'q' && "rgb(187 187 187)",
                                cursor: "pointer",
                                fontSize: 24,
                            }}>
                                <div style={{
                                    height: 40,
                                    width: 40,
                                    backgroundColor: "rgba(75, 70, 92, 0.08)",
                                    borderRadius: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <img src={CartImg} />
                                </div>
                            </div>
                            <p style={{
                                fontWeight: 600, fontSize: 16, letterSpacing: .5,
                                color: reportType == 'q' ? "rgba(75, 70, 92, 1)" : "GrayText",
                                opacity: reportType !== 'q' && .5
                            }}>Quantity</p>
                        </div>
                        <div style={{
                            margin: "20px 10px",
                            textAlign: "center"
                        }}>
                            <div onClick={() => setReportType('m')} style={{
                                margin: "5px 0px",
                                height: 70,
                                width: 80,
                                border: "1.5px solid gray",
                                borderRadius: 4,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: reportType == 'm' && "rgb(187 187 187)",
                                cursor: "pointer",
                                fontSize: 24,
                            }}>
                                <div style={{
                                    height: 40,
                                    width: 40,
                                    backgroundColor: "rgba(75, 70, 92, 0.08)",
                                    borderRadius: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <img src={CartImg} />
                                </div>
                            </div>
                            <p style={{
                                fontWeight: 600, fontSize: 16, letterSpacing: .5,
                                color: reportType == 'm' ? "rgba(75, 70, 92, 1)" : "GrayText",
                                opacity: reportType !== 'm' && .5
                            }}>Minutes</p>
                        </div>

                    </div>
                </div>
                <div>
                    <div style={{
                        display: "flex",
                        // alignItems:"flex-end",
                        backgroundColor: "#fbfbfb"
                    }}>
                        {reportType === "s" && <BarChart dataSet={sales.products} labels={sales.labels} label={"Sales"} />}
                        {reportType === "q" && <BarChart dataSet={sales.quantities} labels={sales.labels} label={"Total Products"} />}
                        {reportType === "m" && <BarChart dataSet={sales.minutes} labels={sales.labels} label={"Total Minutem"} />}

                    </div>
                </div>
            </Card>}
            {/* {fetchLoad ? <LoadingSection /> : <Card sx={{}} title={<strong>Minutes Anaylsis</strong>}>
                <div style={{ margin: "10px 0px 5px 20px" }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <p style={{ fontWeight: 600, fontSize: 16, color: "GrayText" }}>Used Minutes Monthly Overview</p>
                        <div style={{
                            display: "flex",
                            position: "relative",
                            borderRadius: 4,
                            padding: 5,
                            height: 40,
                            width: 200,
                            border: "1px solid lightgray",
                            color: "black",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontSize: 18,
                            margin: "0 20px"
                        }}>
                            {minutesFilter.load ? <Spinner color={"green"} /> : <p style={{ marginRight: 5 }}>{minutesFilter.value}</p>}
                            <div onClick={() => {
                                if (minutesFilter.load) return
                                setMinutesFilter(p => ({ ...p, open: !p.open }))
                            }}
                                style={{ cursor: "pointer" }}
                            >
                                {minutesFilter.open ? <KeyboardArrowUpIcon sx={{ padding: 0, margin: 0 }} /> : <KeyboardArrowDownIcon sx={{ padding: 0, margin: 0 }} color="primay" />}
                            </div>


                            {minutesFilter.open && <div
                                style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 40,
                                    // paddingBottom:20,
                                    zIndex: 99,
                                    //   border: "1px solid lightgray",
                                    borderTop: "0px",
                                    borderRadius: 5,
                                    borderTopLeftRadius: 0,
                                    backgroundColor: "#f6f6f7",
                                }}
                            >
                                <div className='year-list' style={{ height: 120, overflow: "scroll", overflowX: "hidden" }}>
                                    {formatYears().map((h, i) => (
                                        <div
                                            onClick={async (e) => { await handelSelectMinutes(e, h) }}
                                            style={{
                                                cursor: "pointer",
                                                height: 40,
                                                width: 200,
                                                backgroundColor: "",
                                                // borderBottom: "1px solid lightgray",
                                                display: "flex",
                                                padding: 10,
                                                alignItems: "center",
                                                fontWeight: 400,
                                                fontSize: 16,
                                                color: "#8B8D97",
                                            }}
                                        >
                                            <p>{h}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>}
                        </div>
                    </div>
                    <div style={{
                        minHeight: 300
                    }}>
                        <AreaChart dataset={minutesReport.minutes} labels={minutesReport.labels} label={"Minutes consuming report"} />
                    </div>
                </div>
            </Card>} */}
            {fetchLoad ? <LoadingSection /> : <Card>
                <div style={{ margin: "10px 0px 5px 20px" }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <p style={{ fontWeight: 600, fontSize: 16, color: "GrayText" }}>Subscription Monthly Overview</p>
                        <div style={{
                            display: "flex",
                            position: "relative",
                            borderRadius: 4,
                            padding: 5,
                            height: 40,
                            width: 200,
                            border: "1px solid lightgray",
                            color: "black",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontSize: 18,
                            margin: "0 20px"
                        }}>
                            {subsFilter.load ? <Spinner color={"green"} /> : <p style={{ marginRight: 5 }}>{subsFilter.value}</p>}
                            <div onClick={() => {
                                if (subsFilter.load) return
                                setSubsFilter(p => ({ ...p, open: !p.open }))
                            }}
                                style={{ cursor: "pointer" }}
                            >
                                {subsFilter.open ? <KeyboardArrowUpIcon sx={{ padding: 0, margin: 0 }} /> : <KeyboardArrowDownIcon sx={{ padding: 0, margin: 0 }} color="primay" />}
                            </div>


                            {subsFilter.open && <div
                                style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 40,
                                    // paddingBottom:20,
                                    zIndex: 99,
                                    //   border: "1px solid lightgray",
                                    borderTop: "0px",
                                    borderRadius: 5,
                                    borderTopLeftRadius: 0,
                                    backgroundColor: "#f6f6f7",
                                }}
                            >
                                <div className='year-list' style={{ height: 120, overflow: "scroll", overflowX: "hidden" }}>
                                    {formatSubs().map((h, i) => (
                                        <div
                                            onClick={async (e) => { await handelSelectSubs(e, h) }}
                                            style={{
                                                cursor: "pointer",
                                                height: 40,
                                                width: 200,
                                                backgroundColor: "",
                                                // borderBottom: "1px solid lightgray",
                                                display: "flex",
                                                padding: 10,
                                                alignItems: "center",
                                                fontWeight: 400,
                                                fontSize: 16,
                                                color: "#8B8D97",
                                            }}
                                        >
                                            <p>{h}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>}
                        </div>
                    </div>
                    <div style={{
                        minHeight: 300,
                        width: "100%"
                    }}>
                        <BarChart dataSet={subsReport.subs} labels={subsReport.labels} label={"Newly subscribed plans every month"} color='lightblue' />
                    </div>
                </div>
            </Card>}
        </div>
    )
}

export default ReportsSection